var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-content-wrap" },
      [
        _vm.recentDuplicatedSeminarEntryId
          ? _c("seminar-entry-detail-previous-duplicate", {
              attrs: {
                "seminar-id": _vm.seminar.id,
                "seminar-name": _vm.recentDuplicatedSeminarName,
                "entry-id": _vm.recentDuplicatedSeminarEntryId,
                "entry-date": _vm.recentDuplicatedSeminarEntryDate,
                "data-test": "duplicated-info",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("section", [
          _c(
            "div",
            { staticClass: "boss-layout-block margin-bottom-0" },
            [
              _c(
                "router-link",
                {
                  staticClass: "boss-back-to-list-link",
                  attrs: { to: { name: "seminarEntryTop" } },
                },
                [_vm._v("\n          セミナー応募者一覧\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "boss-layout-block margin-bottom-1" }, [
            _c("div", { staticClass: "boss-title-wrap" }, [
              _c(
                "div",
                { staticClass: "boss-layout boss-layout-gap-between" },
                [
                  _c(
                    "h1",
                    {
                      staticClass: "boss-title-2",
                      attrs: { "data-test": "label-seminar" },
                    },
                    [
                      _vm._v(
                        "\n              セミナーID: " +
                          _vm._s(_vm.seminar.id) +
                          "\n              "
                      ),
                      _c("br"),
                      _vm._v(_vm._s(_vm.seminar.name) + "\n            "),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-layout-block margin-bottom-05" }, [
            _c("div", { staticClass: "boss-layout boss-layout-gap-between" }, [
              _c("div", { staticClass: "pega-width-50-percent" }, [
                _c("div", { attrs: { "data-test": "label-phonetic" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.userPhoneticName) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-layout boss-layout-start boss-layout-baseline boss-layout-gap-small",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "boss-entry-name",
                        attrs: { "data-test": "label-name" },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.userName) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { "data-test": "label-user-id" } }, [
                      _vm._v(
                        "\n                （ID:" +
                          _vm._s(_vm.userId) +
                          "）\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm.isDuplicatedEntries
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content:
                                      "同一セミナーに複数回応募している場合に表示されます。",
                                  },
                                  expression:
                                    "{ content: '同一セミナーに複数回応募している場合に表示されます。'}",
                                },
                              ],
                              staticClass: "boss-status-label",
                              attrs: {
                                "data-test": "label-duplicated-entries",
                              },
                            },
                            [_vm._v("重複応募")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "boss-main-content-wrap" }, [
      _c("div", { staticClass: "boss-layout-block" }, [
        _c("div", [
          _c("div", { staticClass: "boss-layout-block margin-bottom-1" }, [
            _c(
              "ul",
              {
                staticClass: "tabs boss-tabs-menu-list",
                attrs: { id: "boss-tab-menu", "data-tabs": "" },
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "tabs-title",
                    class: { "is-active": _vm.currentTabKey === "resume" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "boss-tabs-link",
                        attrs: { "data-test": "link-resume" },
                        on: {
                          click: function ($event) {
                            return _vm.changeCurrent("resume")
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "boss-tabs-link-icon",
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("g", [
                              _c("path", {
                                attrs: {
                                  d: "M12.5 2.5H7.5H3.75H1.25C0.55625 2.5 0 3.05625 0 3.75V16.25C0 16.9438 0.55625 17.5 1.25 17.5H18.75C19.4438 17.5 20 16.9438 20 16.25V3.75C20 3.05625 19.4438 2.5 18.75 2.5H16.25H12.5ZM16.25 3.75H18.125C18.4688 3.75 18.75 4.03125 18.75 4.375V15.625C18.75 15.9688 18.4688 16.25 18.125 16.25H1.875C1.53125 16.25 1.25 15.9688 1.25 15.625V4.375C1.25 4.03125 1.53125 3.75 1.875 3.75H3.75H7.5H12.5H16.25Z",
                                  fill: "#bf192c",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M13.125 9.375H14.375C14.7188 9.375 15 9.09375 15 8.75C15 8.40625 14.7188 8.125 14.375 8.125H13.125C12.7812 8.125 12.5 8.40625 12.5 8.75C12.5 9.09375 12.7812 9.375 13.125 9.375Z",
                                  fill: "#bf192c",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M15.625 10.625H13.125C12.7812 10.625 12.5 10.9062 12.5 11.25C12.5 11.5938 12.7812 11.875 13.125 11.875H15.625C15.9688 11.875 16.25 11.5938 16.25 11.25C16.25 10.9062 15.9688 10.625 15.625 10.625Z",
                                  fill: "#bf192c",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M8.27492 10.825C8.93742 10.375 9.37492 9.6125 9.37492 8.75C9.37492 7.36875 8.25618 6.25 6.87492 6.25C5.49367 6.25 4.37492 7.36875 4.37492 8.75C4.37492 9.6125 4.81243 10.375 5.47493 10.825C3.69993 11.3687 3.18118 12.85 3.15618 12.9313C3.04993 13.2563 3.22492 13.6125 3.54992 13.7188C3.88117 13.825 4.23117 13.65 4.33742 13.325C4.34992 13.3062 4.84992 11.875 6.87492 11.875C8.86867 11.875 9.38742 13.2687 9.40617 13.325C9.49367 13.5875 9.73742 13.75 9.99992 13.75C10.0624 13.75 10.1312 13.7375 10.1999 13.7188C10.5249 13.6125 10.7062 13.2563 10.5937 12.9313C10.5687 12.85 10.0499 11.3687 8.27492 10.825ZM6.87492 7.5C7.56242 7.5 8.12492 8.0625 8.12492 8.75C8.12492 9.4375 7.56242 10 6.87492 10C6.18742 10 5.62492 9.4375 5.62492 8.75C5.62492 8.0625 6.18742 7.5 6.87492 7.5Z",
                                  fill: "#bf192c",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v("\n                レジュメ\n              "),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "tabs-title",
                    class: { "is-active": _vm.currentTabKey === "message" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "boss-tabs-link",
                        attrs: { "data-test": "link-message" },
                        on: {
                          click: function ($event) {
                            return _vm.changeCurrent("message")
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "boss-tabs-link-icon",
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M18.75 0H5C4.30625 0 3.75 0.55625 3.75 1.25V3.75H1.25C0.55625 3.75 0 4.30625 0 5V13.75C0 14.4438 0.55625 15 1.25 15H3.75V18.75C3.75 19.2563 4.05625 19.7125 4.51875 19.9062C4.675 19.9688 4.8375 20 5 20C5.325 20 5.64375 19.875 5.88125 19.6313L10.5188 15H15C15.6938 15 16.25 14.4438 16.25 13.75V11.25H18.75C19.4438 11.25 20 10.6938 20 10V1.25C20 0.55625 19.4438 0 18.75 0ZM15 13.125C15 13.4688 14.7188 13.75 14.375 13.75C14.375 13.75 11.0375 13.75 10.5188 13.75C10 13.75 9.6375 14.1187 9.6375 14.1187L5 18.75V14.375C5 14.0312 4.71875 13.75 4.375 13.75H1.875C1.53125 13.75 1.25 13.4688 1.25 13.125V5.625C1.25 5.28125 1.53125 5 1.875 5H14.375C14.7188 5 15 5.28125 15 5.625V13.125ZM18.75 9.375C18.75 9.71875 18.4688 10 18.125 10H16.25V5C16.25 4.30625 15.6938 3.75 15 3.75H5V1.875C5 1.53125 5.28125 1.25 5.625 1.25H18.125C18.4688 1.25 18.75 1.53125 18.75 1.875V9.375Z",
                                fill: "#bf192c",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M4.375 8.75H7.5C7.84375 8.75 8.125 8.46875 8.125 8.125C8.125 7.78125 7.84375 7.5 7.5 7.5H4.375C4.03125 7.5 3.75 7.78125 3.75 8.125C3.75 8.46875 4.03125 8.75 4.375 8.75Z",
                                fill: "#bf192c",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M11.875 10H4.375C4.03125 10 3.75 10.2812 3.75 10.625C3.75 10.9688 4.03125 11.25 4.375 11.25H11.875C12.2188 11.25 12.5 10.9688 12.5 10.625C12.5 10.2812 12.2188 10 11.875 10Z",
                                fill: "#bf192c",
                              },
                            }),
                          ]
                        ),
                        _vm._v("\n                メッセージ\n              "),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "boss-layout-block" },
            [
              _c(
                "keep-alive",
                [
                  _c(_vm.tabs[_vm.currentTabKey], {
                    tag: "component",
                    attrs: {
                      "entry-id": _vm.entryId,
                      "is-withdraw": _vm.isWithdraw,
                      "data-test": "tab-content",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }